import { createGlobalStyle } from 'styled-components'
import btnHome from 'assets/img/common/btnHome.png'
import btnBack from 'assets/img/common/btnBack.png'
import btnHomeCps from 'assets/img/common/btnHomeCps.png'
import btnBackCps from 'assets/img/common/btnBackCps.png'
import AsicsBold from 'assets/fonts/ASICSFONT3.0-BOLD.woff2'
import AsicsBoldItalic from 'assets/fonts/ASICSFONT3.0-BOLDITALIC.woff2'
import AsicsItalic from 'assets/fonts/ASICSFONT3.0-ITALIC.woff2'
import AsicsRegular from 'assets/fonts/ASICSFONT3.0-REGULAR.woff2'
import AsicsRg from 'assets/fonts/ASICSSPORTSTYLE_RG.woff2'
import AsicsSportStyleRg from 'assets/fonts/ASICSSPORTSTYLE_RG.woff2'
import BtnPopupClose from 'assets/img/common/PopupCloseBtn.png'

import BtnHomeCps2026 from 'assets/img/cps/btn_home.png'
import BtnBackCps2026 from 'assets/img/cps/btn_back.png'

/**
 * 공통 스타일
 */
const GlobalStyles = createGlobalStyle`

    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        // cursor: none;
    }

    ::webit-scrollbar {
        display: none;
    }

    html, body {
        background-color: #EAEAEC;
    }
    @font-face {
        font-family: 'asics bold';
        font-style: normal;
        font-weight: bold;
        font-display: swap;
        src: url(${AsicsBold}) format('woff2');
    }
    @font-face {
        font-family: 'asics bold italic';
        font-style: italic;
        font-weight: bold;
        font-display: swap;
        src: url(${AsicsBoldItalic}) format('woff2');
    }
    @font-face {
        font-family: 'asics italic';
        font-style: italic;
        font-weight: normal;
        font-display: swap;
        src: url(${AsicsItalic}) format('woff2');
    }
    @font-face {
        font-family: 'asics regular';
        font-style: normal;
        font-weight: normal;
        font-display: swap;
        src: url(${AsicsRegular}) format('woff2');
    }
    @font-face {
        font-family: 'asics rg';
        font-style: normal;
        font-weight: normal;
        font-display: swap;
        src: url(${AsicsRg}) format('woff2');
    }
    @font-face {
        font-family: 'asics sport style rg';
        font-style: normal;
        font-weight: normal;
        font-display: swap;
        src: url(${AsicsSportStyleRg}) format('woff2');
    }
    .asics-sport-style-rg {
        font-family: 'asics sport style rg';
    }
    .asics-bold {
        font-family: 'asics bold';
    }
    .asics-bold-italic {
        font-family: 'asics bold italic';
    }
    .asics-italic {
        font-family: 'asics italic';
    }
    .asics-regular {
        font-family: 'asics regular';
    }
    .asics-rg {
        font-family: 'asics rg';
    }
    body {
        position: relative;
        width: 1920px;
        height: 1080px;
        overflow: hidden;
        font-family: 'Noto Sans KR';
        font-weight: 400;
    }
    .container {
        position: relative;
        width: 1920px;
        height: 1080px;
        overflow: hidden;
        .speedImg {
            position: absolute;
            top: 55px;
            left: 90px;
        }
        .diffItemContainer {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 320px;
            // background: rgba(244, 246, 250, 0.8);
            display: flex;
            align-items: center;
            .msg {
                position: absolute;
                left: 642px;
                top: 0;
            }
            .category {
                position: absolute;
                bottom: 32px;
                right: 444px;
            }
            .sex {
                width: 144px;
                line-height: 46px;
                background: #001E62;
                color: #fff;
                font-size: 20px;
                font-family: 'asics bold';
                text-align: center;
                border-radius: 100px;
                margin-right: 20px;
            }
            .diffItems {
                position: absolute;
                top: 0px;
                left: 695px;
                right: 0;
                bottom: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                .diffRow {
                    margin-bottom: 20px;
                    &:last-of-type {
                        margin-bottom: 0;
                    }
                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                        width: 905px;
                        // height: 75px;
                        // display: flex;
                        // align-items: center;
                        // justify-content: center;
                        // overflow-x: scroll;
                        // overflow-y: hidden;
                        // white-space: nowrap;
                        // -webkit-overflow-scrolling: touch;
                        // &::-webkit-scrollbar {
                        //     display: none;
                        // }
                        li {
		                    display: inline-block;
                            margin-right: 35px;
                            &:first-of-type {
                                margin-left: 10px;
                            }
                            button {
                                position: relative;
                                border: 0;
                                outline: 0;
                                background: transparent;
                                width: 145px;
                                height: 145px;
                                & > img {
                                    max-width: 100%;
                                    max-height: 100%;
                                }
                                .sizeSoldOut {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    z-index: 10;
                                    transform: translate(-50%, -50%);
                                }
                                .soldOut {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    z-index: 20;
                                    transform: translate(-50%, -50%);
                                }
                            }
                        }
                    }
                }
            }
        }
        .diffItemContainer2 {
            position: absolute;
            bottom: 0;
            right: 130px;
            width: 650px;
            height: 320px;
            // background: rgba(244, 246, 250, 0.8);
            display: flex;
            align-items: center;
            .indexImage {
                position: absolute;
                bottom: 42px;
                right: 20px;
                display: block;
            }
            .otherColor {
                position: absolute;
                bottom: 268px;
                right: -40px;
            }
            .sex {
                width: 144px;
                line-height: 46px;
                background: #001E62;
                color: #fff;
                font-size: 20px;
                font-family: 'asics bold';
                text-align: center;
                border-radius: 100px;
                margin-right: 20px;
            }
            .diffItems {
                position: absolute;
                top: 0px;
                left: 0;
                right: 0;
                bottom: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                .diffRow {
                    margin-bottom: 20px;
                    &:last-of-type {
                        margin-bottom: 0;
                    }
                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                        width: 1600px;
                        // height: 75px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        overflow-x: scroll;
                        overflow-y: hidden;
                        white-space: nowrap;
                        -webkit-overflow-scrolling: touch;
                        &::-webkit-scrollbar {
                            display: none;
                        }
                        li {
		                    display: inline-block;
                            margin-right: 45px;
                            width: 145px;
                            button {
                                position: relative;
                                border: 0;
                                outline: 0;
                                background: transparent;
                                width: 145px;
                                // width: 150px;
                                // height: 75px;
                                & > img {
                                    max-width: 150px;
                                }
                                .sizeSoldOut {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    z-index: 10;
                                    transform: translate(-50%, -50%);
                                }
                                .soldOut {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    z-index: 20;
                                    transform: translate(-50%, -50%);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .cpsBtnContainer {
        position: absolute;
        bottom: 50px;
        left: 60px;
        list-style: none;
        padding: 0;
        margin: 0;
        z-index: 100;
        li {
            display: inline-block;
        }
        .btnHome, .btnBack {
            width: 80px;
            height: 80px;
            border: 0;
            outline: 0;
        }
        .btnHome {
            background: url(${BtnHomeCps2026}) no-repeat;
            background-size: 100% 100%;
            margin-right: 20px;
        }
        .btnBack {
            background: url(${BtnBackCps2026}) no-repeat;
            background-size: 100% 100%;}
    }
    .btnContainer {
        position: absolute;
        bottom: 50px;
        left: 60px;
        list-style: none;
        padding: 0;
        margin: 0;
        z-index: 100;
        li {
            display: inline-block;
        }
        .btnHome, .btnBack {
            width: 80px;
            height: 80px;
            border: 0;
            outline: 0;
        }
        .btnHome {
            background: url(${btnHome}) no-repeat;
            background-size: 100% 100%;
            margin-right: 20px;
        }
        .btnBack {
            background: url(${btnBack}) no-repeat;
            background-size: 100% 100%;}
    }
    .btnContainerCps {
        position: absolute;
        bottom: 50px;
        left: 60px;
        list-style: none;
        padding: 0;
        margin: 0;
        z-index: 100;
        li {
            display: inline-block;
        }
        .btnHome {
            width: 78px;
            height: 56px;
            border: 0;
            outline: 0;
        }
        .btnBack {
            width: 61px;
            height: 56px;
            border: 0;
            outline: 0;
        }
        .btnHome {
            background: url(${btnHomeCps}) no-repeat;
            background-size: 100% 100%;
            margin-right: 46px;
        }
        .btnBack {
            background: url(${btnBackCps}) no-repeat;
            background-size: 100% 100%;}
    }
    @keyframes rotate {
        0%,
        75% {
            transform: rotateY(360deg);
        }
    }
    .sideNav {
        position: absolute;
        left: 80px;
        top: 250px;
        list-style: none;
        margin: 0;
        padding: 20px 10px 20px 0;
        width: 200px;
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        li {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
            &.active {
                button {
                    color: #fff;
                    text-indent: -10px;
                    &.techBtn {
                        text-indent: 0;
                        &:after {
                            width: calc(100% + 20px);
                            background: #212322;
                        }
                    }
                    &:after {
                        width: calc(100% + 20px);
                        background: #212322;
                    }
                }
            }
            button {
                position: relative;
                font-size: 32px;
                font-weight: 600;
                border: 0;
                outline: 0;
                padding: 10px 20px;
                line-height: 1;
                background: transparent;
                border-radius: 5px;
                font-weight: 400;
                width: 200px;
                height: 60px;
                transform: translateX(-10px);
                text-align: center;
                &.techBtn {
                    background: #202b4e;
                    color: #fff;
                    span.tech {
                        display: inline-flex;
                        animation: rotate 2s infinite;
                    }
                }
                span {
                    position: relative;
                    z-index: 2;
                }
                &:after {
                    content: '';
                    display: block;
                    position: absolute;
                    left: -20px;
                    top: 0;
                    right: 0;
                    height: 100%;
                    width: 0;
                    z-index: 1;
                    transition: all 0.15s ease-in-out;
                    border-radius: 5px;
                }
                transition: all 0.15s ease-in-out;
            }
        }
    }
    .sideNav2{
        position: absolute;
        left: 80px;
        top: 250px;
        list-style: none;
        margin: 0;
        padding: 20px 10px 20px 0;
        width: 200px;
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        li {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
            &.active {
                button {
                    color: #fff;
                    background: #001E62;
                    //text-indent: -10px;
                    &.techBtn {
                        text-indent: 0;
                        color: #fff;
                        &:after {
                            // width: calc(100% + 20px);
                            // background: #212322;
                        }
                    }
                    &:after {
                        // width: calc(100% + 20px);
                        // background: #212322;
                    }
                }
            }
            button {
                position: relative;
                font-size: 32px;
                font-weight: 600;
                border: 0;
                outline: 0;
                padding: 10px 20px;
                line-height: 1;
                background: rgba(255, 255, 255, 0.3);
                border-radius: 5px;
                font-family: 'asics italic';
                font-weight: 400;
                width: 200px;
                height: 60px;
                transform: translateX(-10px);
                text-align: center;
                border-radius: 1000px;
                color: #001F66;
                border: 1px solid #001F66;
                &.techBtn {
                    font-family: 'asics bold italic';
                    span.tech {
                        display: inline-flex;
                        animation: rotate 3s infinite;
                    }
                }
                span {
                    position: relative;
                    z-index: 2;
                }
                &:after {
                    content: '';
                    display: block;
                    position: absolute;
                    left: -20px;
                    top: 0;
                    right: 0;
                    height: 100%;
                    width: 0;
                    z-index: 1;
                    transition: all 0.15s ease-in-out;
                    border-radius: 5px;
                }
                transition: all 0.15s ease-in-out;
            }
        }
    }
    @keyframes flick {
      0% {
        background-position: top left;
      }
      100% {
        background-position: top right;
      }
    }
    .popupContainer {
        position: absolute;
        left: 2000px;
        top: 32px;
        width: 1540px;
        height: 1010px;
        z-index: 1000;
        // background: #EFF1F5;
        border-radius: 45px;
        overflow: hidden;
        box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
        transition: all 0.15s ease-in-out;
        visibility: hidden;
        &.active {
            visibility: visible;
            left: 357px;
        }
        .btnPopupClose {
            position: absolute;
            top: 23px;
            right: 23px;
            width: 75px;
            height: 75px;
            border: 0;
            outline: 0;
            background: url(${BtnPopupClose}) no-repeat;
            z-index: 10000;
        }
        .colorContainer {
            background: rgba(255, 255, 255, 0.5);
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                max-width: 1540px;
                max-height: 1010px;
            }
        }
        .slideContainer {
            background: rgba(255, 255, 255, 0.5);
            position: relative;
            width: 1540px;
            height: 1010px;
            .slick-slider .slick-list {
                width: 1540px;
                height: 1010px;
            }
            .slick-slide img {
            }
        }
        .videoContainer {
            background: #000;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            li {
                width: 1540px;
                height: 1010px;
            }
            video {
                max-width: 1540px;
                max-height: 1010px;
                width: 100%;
                height: 100%;
            }
        }
        .videoContainerSlider {
            background: #000;
            height: 1010px;
            li {
                width: 1540px;
                height: 1010px;
                video {
                    max-width: 1540px;
                    max-height: 1010px;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .noData {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        font-weight: 600;
        text-align: center;
    }
    .noList {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        font-weight: 600;
        text-align: center;
    }
    .itemNameRight {
        position: absolute;
        right: 770px;
        top: 43px;
        font-size: 27px;
        line-height: 1;
        color: #353535;
        font-weight: 300;
        display: flex;
        align-items: center;
        .colorTitle {
            color: #fff;
            background: #353535;
            border-radius: 100px;
            text-align: center;
            width: 190px;
            line-height: 40px;
            letter-spacing: 1px;
            font-size: 20px;
            margin-right: 20px;
        }
        span {
            margin-left: 10px;
            margin-right: 0px;
        }
    }
    .itemName {
        position: absolute;
        left: 780px;
        top: 43px;
        font-size: 27px;
        line-height: 1;
        color: #353535;
        font-weight: 300;
        display: flex;
        align-items: center;
        .colorTitle {
            color: #fff;
            background: #353535;
            border-radius: 100px;
            text-align: center;
            width: 190px;
            line-height: 40px;
            letter-spacing: 1px;
            font-size: 20px;
            margin-right: 20px;
        }
    }
    .pageTitle {
        position: absolute;
        top: 68px;
        left: 58px;
        font-size: 40px;
        color: #2f302f;
        min-width: 210px;
        text-align: center;
        line-height: 1;
        .bar {
            width: 200px;
            height: 10px;
            background: #8bc191;
            margin: 15px auto;
        }
        span {
            font-size: 50px;
        }
    }
    .pageTitle2 {
        position: absolute;
        top: 35px;
        left: 35px;
        font-size: 40px;
        color: #2f302f;
        min-width: 210px;
        line-height: 1;
        // background: rgba(255, 255, 255, 0.2);
        padding: 10px 20px;
        p {
            font-size: 26px;
            margin-top: 10px;
        }
    }
    .pageTitle3 {
        position: absolute;
        top: 35px;
        left: 35px;
        font-size: 34px;
        color: #2f302f;
        min-width: 210px;
        line-height: 1;
        background: rgba(255, 255, 255, 0.2);
        padding: 10px 20px;
        p {
            font-size: 26px;
            margin-top: 10px;
        }
    }
    .keyVisualContainer {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 700px;
        height: 1080px;
        background: #fff;
    }
    .keyVisualLeftContainer {
        position: absolute;
        top: 35px;
        left: 340px;
        width: 650px;
        height: 1010px;
        background: #fff;
        overflow: hidden;
    }
    .horizontalScrollerContainer {
        height: 145px;
        overflow-x: auto;
        display: flex;
        align-items: center;
        justify-content: safe center; 
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
        &::-webkit-scrollbar {
            display: none;
        }
        li {
            list-style: none;
            margin-right: 35px;
            position: relative;
            flex-shrink: 0; /* 자식 요소들이 찌그러지지 않고 원래 크기를 유지하게 함 */
        }
    }
    .sizeSoldOut {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 10;
        transform: translate(-50%, -50%);
    }
    .soldOut {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 20;
        transform: translate(-50%, -50%);
    }
`

export default GlobalStyles
